import type { FC } from 'react';

import styled from 'styled-components';

const CDN_BASE = 'https://cdn.rpdy.us/staticassets';
const MSI_LOGO_URL = `${CDN_BASE}/msi-logo-rgb-h-public_rev-dark-blue-circle-core.png`;

const StyledHeader = styled.div`
	background-color: #213f59;

	display: flex;
	justify-content: center;
	padding: 1.5rem;
`;

const StyledLogo = styled.img`
	max-width: 14rem;
	width: 100%;
	height: auto;
`;

const Header: FC = () => (
	<StyledHeader>
		<StyledLogo src={MSI_LOGO_URL} alt="Motorola Solutions" />
	</StyledHeader>
);

export default Header;
